import SmoothScroll from 'smooth-scroll';
import { transformHeaderOnScroll, toggleMobileMenu } from "./header.js"
import Plyr from 'plyr';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Collapse from 'bootstrap/js/dist/collapse';
import Modal from 'bootstrap/js/dist/modal';
import animateOnScroll from "./animateOnScroll";

animateOnScroll([
	{ selector: ".fade-in-bottom", offset: 0.15, multiple: true },
]);

//Init SmoothScroll
new SmoothScroll('a[href*="#"], a.scroll, li.scroll', {
    //header: '[data-scroll-header]'
});

//Init Bootstrap Dropdown
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(el => {
        new Dropdown(el);
    });
});
//Init Bootstrap Collapse
document.querySelectorAll('[data-bs-toggle="collapse"]').forEach(el => {
    new Collapse(el, { toggle: false });
});



const header = document.querySelector("header");
const threshold = 40;
const menuTrigger = document.querySelector('.hamburger');

//Init Header Scroll Animation Event
if (header && threshold) window.addEventListener('scroll', function () { transformHeaderOnScroll(header, threshold); } );

//Init Mobile Menu Event
if (menuTrigger && header) menuTrigger.addEventListener('click', function () { toggleMobileMenu(header, menuTrigger); });

//Closes mobile menu when link with class scroll is clicked
if (document.querySelectorAll('.scroll')) {
    const scrollNav = document.querySelectorAll('.scroll a');
    scrollNav.forEach(function (nav) {
        nav.addEventListener("click", () => {

            //If child submenu is active remove active class
            if (document.querySelectorAll('.menu-item-has-children.active')) {
                document.querySelectorAll('.menu-item-has-children.active').forEach(function (dropDown) {
                    dropDown.classList.remove('active');
                });
            }
            //If mobile menu is active toggle activeMenu and isActive classes
            if (header.classList.contains('activeMenu')) {
                header.classList.toggle('activeMenu');
                menuTrigger.classList.toggle('isActive');
            }
        });
    });
}

// Sub Menu for Mobile — only runs on old nav
if (!document.querySelector('.navbar-v2')) {
    let plusIcon = '<span class="dropIcon"><i class="fa fa-plus" aria-hidden="true"></i><i class="fa fa-minus" aria-hidden="true"></i></span>'

    document.querySelectorAll('.menu-item-has-children a').forEach(function (menu) {
        if (menu.parentElement.classList.contains('menu-item-has-children')) {
            menu.insertAdjacentHTML('beforebegin', plusIcon);
        }
    });

    document.querySelectorAll('.dropIcon').forEach(function (icon) {
        icon.addEventListener("click", () => {
            if (icon.parentElement.classList.contains('active')) {
                icon.parentElement.classList.remove('active');
            } else {
                icon.parentElement.classList.add('active');
            }
        });
    });
}

//global video player plugin
window.addEventListener('DOMContentLoaded', () => {
	const players = Array.from(document.querySelectorAll('.js-player')).map((p) => {
		const poster = p.getAttribute('data-poster') || '';
		const wrap = p.closest('.has-custom-poster');
		const player = new Plyr(p, {
			clickToPlay: true,
			controls: ['play-large'],
			youtube: {
				noCookie: false
			},
			fullscreen: {
				enabled: true,
				fallback: true,
				iosNative: true
			}
		});

		if (poster) {
			const syncPoster = () => {
				player.poster = poster;
			};
			syncPoster();
			player.on('ready', syncPoster);
		}

		if (wrap) {
			// Gate all pre-play CSS off this class — do not toggle on pause
			const markPlayed = () => wrap.classList.add('has-played');
			player.on('play', markPlayed);
			player.on('playing', markPlayed);
			player.on('ended', () => wrap.classList.remove('has-played'));
			player.on('stop', () => wrap.classList.remove('has-played'));
		}

		return player;
	});
	players.forEach((player) => {
		player.on('ended', function () {
			player.stop();
		});
	});

	// Ensure Bootstrap modals work with modular import
	document.querySelectorAll('.modal').forEach((modalEl) => {
		Modal.getOrCreateInstance(modalEl);
		modalEl.addEventListener('hidden.bs.modal', () => {
			players.forEach((player) => player.stop());
		});
	});
});

//Gravity Form UTM Tracking (Pantheon Strips UTM Tracking by default)
window.onload = function() {
    const wrappers = document.getElementsByClassName("gform_wrapper");
    for (const element of wrappers) {
        const gfID = element.id;
        const anchorID = gfID.replace(/\D/g, "");
        const source = window.location.pathname + window.location.search;
        element.getElementsByTagName("form")[0].action = source + "#gf_" + anchorID;
        console.log('GF-UTM');
    }
}